<template>
  <div class="mainContainer normalText" v-if="caregiver" v-loading="fullPageLoading">
    <el-row class="section">
      <el-col :span="18">
        <div class="header-36-black">ผู้ดูแล <span class='header-36-white'> {{ caregiver.id }} </span></div>
        <h4 style="color:#c0c4cc; font-size:14px; font-weight:600; margin-top:16px;">ชื่อผู้ดูแล &nbsp;<span style="font-weight:300;">{{caregiver.nickName}} {{caregiver.name}}</span></h4>
      </el-col>
      <el-col class="right" :span="6" v-if="isCaregiverinfoTab">
        <el-button class="edit" type="primary" @click="editCaregiver" plain="plain">แก้ไข</el-button>
      </el-col>
    </el-row>
    <el-row class="section" style="padding-top:0;">
      <el-tabs v-model="tabSelected" @tab-click="handleClick">
        <el-tab-pane label="ข้อมูลผู้ดูแล" name="caregiverinfoTab"></el-tab-pane>
        <el-tab-pane label="พฤติกรรม" name="caregiverBehavior"></el-tab-pane>
        <el-tab-pane label="ตารางเวร" name="workcalendarTab"></el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row v-if="isCaregiverinfoTab">
      <caregiver-card :caregiverData="caregiver"></caregiver-card>
      <el-row class="section">
        <el-col class="columnLeft" :span="12">
          <div>
            <el-row class="sectionHeader">ข้อมูลผู้ดูแล</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">ชื่อเล่น</el-col>
                <el-col class="description" :span="14">{{caregiver.nickName || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ชื่อจริง-นามสกุล</el-col>
                <el-col class="description" :span="14">{{caregiver.name || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">เพศ</el-col>
                <el-col class="description" :span="14">{{caregiver.gender || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">วันเกิด</el-col>
                <el-col class="description" :span="14">{{caregiver.birthDate || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">อายุ</el-col>
                <el-col v-if="caregiver.age" class="description" :span="14">{{caregiver.age}} ปี</el-col>
                <el-col v-else class="description" :span="14">-</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">น้ำหนัก</el-col>
                <el-col v-if="caregiver.weight" class="description" :span="14">{{caregiver.weight}} กก.</el-col>
                <el-col v-else class="description" :span="14">-</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ส่วนสูง</el-col>
                <el-col v-if="caregiver.height" class="description" :span="14">{{caregiver.height}} ซม.</el-col>
                <el-col v-else class="description" :span="14">-</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">สถานภาพ</el-col>
                <el-col class="description" :span="14">{{caregiver.maritalStatus || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">บุตร</el-col>
                <el-col class="description" :span="14">{{children || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ศาสนา</el-col>
                <el-col class="description" :span="14">{{religion || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">เลขบัตรประชาชน</el-col>
                <el-col class="description" :span="14">{{caregiver.citizenId || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">รูปบัตรประชาชน</el-col>
                <el-col v-if="!caregiver.citizenIdPhoto" class="description" :span="14">-</el-col>
                <el-col v-else class="description" :span="14"><img class="fit" v-if="caregiver.citizenIdPhoto" :src="caregiver.citizenIdPhoto" width="200px" height="200px" /></el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ไซส์เสื้อ</el-col>
                <el-col class="description" :span="14">{{caregiver.shirtSize || '-'}}</el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">การติดต่อ</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">เบอร์โทร</el-col>
                <el-col class="description" :span="14">{{caregiver.phone || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ไลน์ไอดี</el-col>
                <el-col class="description" :span="14">{{caregiver.line || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ชื่อผู้ติดต่อฉุกเฉิน</el-col>
                <el-col class="description" :span="14">{{caregiver.emergencyContact.name || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ความสัมพันธ์ต่อผู้ดูแล</el-col>
                <el-col class="description" :span="14">{{caregiver.emergencyContact.relation || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">เบอร์โทรผู้ติดต่อฉุกเฉิน</el-col>
                <el-col class="description" :span="14">{{caregiver.emergencyContact.phone || '-'}}</el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">สถานที่อยู่</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">สถานที่อยู่ปัจจุบัน</el-col>
                <el-col class="description" :span="14">{{caregiver.address.address || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">จังหวัด</el-col>
                <el-col class="description" :span="14">{{caregiver.address.province || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">อำเภอ/เขต</el-col>
                <el-col class="description" :span="14">{{caregiver.address.district || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ตำบล/แขวง</el-col>
                <el-col class="description" :span="14">{{caregiver.address.subdistrict || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ภูมิลำเนา</el-col>
                <el-col class="description" :span="14">{{caregiver.hometown || '-'}}</el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">การศึกษา</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">วุฒิการศึกษาสูงสุด</el-col>
                <el-col class="description" :span="14">{{caregiver.education || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">สถานศึกษาสูงสุด</el-col>
                <el-col class="description" :span="14">{{caregiver.educationPlace || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ประกาศนียบัตรการดูแล</el-col>
                <el-col class="description" :span="14">{{caregiver.careCertification || '-'}} {{caregiver.careCertificationPlace}}</el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">ช่องทางการรับเงิน</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">ธนาคาร</el-col>
                <el-col class="description" :span="14">{{caregiver.bankAccount.bank || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ชื่อบัญชี</el-col>
                <el-col class="description" :span="14">{{caregiver.bankAccount.name || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">เลขบัญชี</el-col>
                <el-col class="description" :span="14">{{caregiver.bankAccount.number || '-'}}</el-col>
              </el-row>
            </el-row>
          </div>
        </el-col>
        <el-col class="columnRight" :span="12">
          <div>
            <el-row class="sectionHeader">ภาพรวม</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">ภาพรวม</el-col>
                <el-col class="description" :span="14">{{caregiver.overviewNote || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">บุคลิกภาพ</el-col>
                <el-col class="description" :span="14">{{caregiver.personalityNote || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ทักษะ</el-col>
                <el-col class="description" :span="14">{{caregiver.skillNote || '-'}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ไม่เหมาะกับเคส</el-col>
                <el-col class="description" :span="14">{{caregiver.notSuitableNote || '-'}}</el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">ประสบการณ์การดูแล</el-row>
            <el-row class="grayBackground blockStyle">
              <el-row>
                <el-col class="title" :span="10">ประเภทผู้ดูแล</el-col>
                <el-col class="description" :span="14">{{caregiver.type || '-'}}</el-col>
              </el-row>
              <el-row v-if="caregiver.class !== 0 &amp;&amp; caregiver.classYear !== 0 ">
                <el-col class="title" :span="10">รุ่น</el-col>
                <el-col class="description" :span="14">{{caregiver.class}}/{{caregiver.classYear}}</el-col>
              </el-row>
              <el-row>
                <el-col class="title" :span="10">ระยะเวลาการทำงาน</el-col>
                <el-col v-if="caregiver.yearOfExp" class="description" :span="14">{{caregiver.yearOfExp}} ปี</el-col>
                <el-col v-else class="description" :span="14">-</el-col>
              </el-row>
              <el-row style="margin-top: 32px; margin-bottom: 8px;">
                <el-col>
                  <div style="color: #434B61; font-size: 18px; font-weight: 700;">ทักษะทั่วไป</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="display: flex; flex-direction: column; gap: 8px;">
                  <div
                      v-for="s in caregiver.generalSkills"
                      :key="s.name"
                      style="width: 100%; display: flex; justify-content: space-between"
                  >
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <img
                          v-if="s.improvable || s.score >= 7"
                          src="https://storage.healthathome.in.th/7f01aa68-a08a-48f3-85ab-4fd889bff8a6.svg"
                          alt="pass"
                          style="width: 14px; height: 14px"
                      >
                      <img
                          v-else
                          src="https://storage.healthathome.in.th/c37ba476-3302-4042-9703-f1671da02c14.svg"
                          alt="not-pass"
                          style="width: 14px; height: 14px"
                      >
                      <span
                          style="font-family: 'Sukhumvit-Medium'; font-size: 18px; white-space: nowrap; color: #434B61;"
                      >
                          {{ s.name }}
                        </span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 16px;">
                      <img
                          v-if="s.improvable"
                          src="https://storage.healthathome.in.th/99391011-c3de-4b82-9408-a935a719c802.svg"
                          alt="improveble"
                          style="width: 14px; height: 14px"
                      >
                      <span style="width: 24px; font-family: 'Sukhumvit-Medium'; color: #434B61; font-size: 18px; text-align: right; white-space: nowrap;">
                        {{ s.score ? s.score : '-' }}
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top: 32px; margin-bottom: 8px;">
                <el-col>
                  <div style="color: #434B61; font-size: 18px; font-weight: 700;">ทักษะอื่น ๆ</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="display: flex; flex-direction: column; gap: 8px;">
                  <div
                      v-for="s in caregiver.otherSkills"
                      :key="s.name"
                      style="width: 100%; display: flex; justify-content: space-between"
                  >
                    <div style="display: flex; align-items: center; gap: 12px;">
                      <img
                          v-if="s.improvable || s.score >= 7"
                          src="https://storage.healthathome.in.th/7f01aa68-a08a-48f3-85ab-4fd889bff8a6.svg"
                          alt="pass"
                          style="width: 14px; height: 14px"
                      >
                      <img
                          v-else
                          src="https://storage.healthathome.in.th/c37ba476-3302-4042-9703-f1671da02c14.svg"
                          alt="not-pass"
                          style="width: 14px; height: 14px"
                      >
                      <span
                          style="font-family: 'Sukhumvit-Medium'; font-size: 18px; white-space: nowrap; color: #434B61;"
                      >
                          {{ s.name }}
                        </span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 16px;">
                      <img
                          v-if="s.improvable"
                          src="https://storage.healthathome.in.th/99391011-c3de-4b82-9408-a935a719c802.svg"
                          alt="improveble"
                          style="width: 14px; height: 14px"
                      >
                      <span style="width: 24px; font-family: 'Sukhumvit-Medium'; color: #434B61; font-size: 18px; text-align: right; white-space: nowrap;">
                        {{ s.score ? s.score : '-' }}
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-row>
          </div>
          <div>
            <el-row class="sectionHeader">ลิงค์ไฟล์</el-row>
            <el-row class="grayBackground blockStyle">
              <div>
                <el-col class="title" :span="10">เอกสารอื่นๆ</el-col>
                <el-col class="description" :span="14" v-html="changeTextToLink || '-'"></el-col>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-row>
    <CaregiverBehavior v-if="isBehaviorTab" :caregiverId="id"></CaregiverBehavior>
    <caregiver-matched-calendar class="section" v-if="isWorkcalendarTab" :caregiverId="id"></caregiver-matched-calendar>
  </div>
</template>

<style lang='scss' scoped>

  h4 {
    font-family: 'Sukhumvit-Medium';
  }

  .el-row {
    margin-bottom: 16px;
  }

  .title {
    font-family: 'Sukhumvit-Bold';
    font-size: 18px;
    font-weight: 600;
    color: #606266;
  }

  .darkGray {
    color: #606266;
  }

  .lightGray {
    color: #c0c4cc;
  }

  .description {
    font-family: 'Sukhumvit-Medium';
    font-size: 18px;
    color: #606266;
    word-wrap: break-word;
    padding-right: 12px;
    white-space: pre-wrap;
  }

  .blockStyle {
    padding-top: 31px;
    padding-left: 32px;
    padding-right: 25px;
    padding-bottom: 32px;
  }

  .columnLeft {
    padding-right: 12px;
  }

  .columnRight {
    padding-left: 12px;
  }

  .bold {
    font-weight: bold;
  }
  .mainContainer {
    padding: 155px 100px 100px;
  }

  .smallContainer {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .normalText {
    font-size: 18px;
    line-height: 1.5;
    color: #303133;
  }

  .right {
    text-align: right;
  }

  .smallText {
    font-size: 14px;
  }

  .section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
  }

  .el-button {
    width: 120px;
  }

  .grayBackground {
    background: #f5f7fa;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .sectionHeader {
    font-family: 'Sukhumvit-Bold';
    padding-left: 32px;
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 24px;
    font-weight: 600;
    color: #606266;
    margin-top: 32px;
    margin-bottom: 0;
  }

  .fit {
    object-fit: cover;
  }

  .edit {
    border: 2px solid #5489FF;
    color: #5489FF;
    font-weight: 900;
    font-size: 18px;
    background-color: white;
  }

  li {
    margin-bottom: 16px;
  }
</style>

<script>
import CaregiverCard from './CaregiverCard'
import CaregiverModel from '../../model/CaregiverModel'
import CaregiverBehavior from './CaregiverBehavior.vue'

import CaregiverMatchedCalendar from './CaregiverMatchedCalendar'
import { Readable } from '../../model/ModelUtil'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'CaregiverDetail',
  mixins: [GenericAPIHandler],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  components: {
    CaregiverCard,
    CaregiverMatchedCalendar,
    CaregiverBehavior,
  },
  data () {
    return {
      caregiver: null,
      fullPageLoading: false,
      tabSelected: '',
    }
  },
  mounted () {
    this.getCaregiver()
  },
  computed: {
    children () {
      let number = this.caregiver.hasChildren === 'มีบุตร' ? ` จำนวน ${this.caregiver.children}` : ''
      return this.caregiver.hasChildren + number
    },
    religion () {
      return Readable.religion.from(this.caregiver.religion)
    },
    isCaregiverinfoTab () {
      return this.tabSelected === 'caregiverinfoTab'
    },
    isWorkcalendarTab () {
      return this.tabSelected === 'workcalendarTab'
    },
    isBehaviorTab () {
      return this.tabSelected === 'caregiverBehavior'
    },
    changeTextToLink () {
      let urlRegex = /(https?:\/\/[^\s]+)/g
      return this.caregiver.note.replace(urlRegex, function (url) {
        return `<a target="new" href="${url}">${url}</a>`
      })
    },
  },
  methods: {
    async getCaregiver () {
      try {
        this.tabSelected = this.$route.query.tab
        this.fullscreenLoading = true
        let raw = await this.$api.Caregiver.get(this.id)
        this.caregiver = CaregiverModel.fromJSON(raw).transformToDisplayable()
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    editCaregiver () {
      this.$router.push({ name: 'CaregiverEdit', params: { id: this.id } })
    },
    handleClick (tab, event) {
      this.$router.push({ name: 'CaregiverDetail', params: { id: this.id }, query: { tab: tab.name } })
    },
  },
}
</script>
